export default __webpack_public_path__ + "static/media/mct.0d63ecc7.png";